import { combineReducers } from "redux";
import authReducer from "../redusers/AuthReducer";
import ManageEmpReduser from "../redusers/ManageEmpReduser";
import CarReduser from "../redusers/CarsReduser";
import ApplicationReduser from "../redusers/ApplicationReduser";
import PaymentReduser from "../redusers/PaymentReduser";
import TouristReduser from "../redusers/TouristReduser";
import ContactusReduser from "../redusers/ContactusReduser";
import SlideReduser from "../redusers/sliderReduser";

export default combineReducers({
  authReducer,
  ManageEmpReduser,
  CarReduser,
  ApplicationReduser,
  PaymentReduser,
  TouristReduser,
  ContactusReduser,
  SlideReduser
});
